import React from 'react';
import styled from 'styled-components';
import { Header } from '@app/navigation/header';
import { Body } from '@ui';
import { Body1, Body5, Container, Page } from '@ui';
import { useSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router';
import { ROUTES } from '@constants/routes';
import BackArrowButton from '@ui/buttons/BackArrowButton';
import { ModeContext } from '../contexts/ModeContext';
import { AnswerConfigContext } from '../contexts/AnswerConfigContext';
import { AI_TOOLS } from '@constants';
import StreamingResult from '@features/result/StreamingResult';

const PageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

const modeContext = {
  tool: AI_TOOLS.AGENT_FLOW,
};

const answerConfig = {
  enableMoreDetail: false,
  enableLinks: true,
  ignoreLatex: false,
  //   enableRating: false,
  //   enableShare: false,
};

const AgentResultViewer = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id');

  const onGoBack = () => navigate(ROUTES.home);

  return (
    <PageWrapper>
      <Header />
      <Body withFooter>
        <Page width={'1600px'}>
          <BackArrowButton onClick={onGoBack} />

          <Container top={44}>
            <Body1 bold>Agent Result</Body1>
          </Container>

          <Container top={24}>
            <ModeContext.Provider value={modeContext}>
              <AnswerConfigContext.Provider value={answerConfig}>
                {id ? (
                  <StreamingResult resultId={id} isAgentScriptResult />
                ) : (
                  <Body5>No result ID provided. Use ?id=&lt;result_id&gt; in the URL.</Body5>
                )}
              </AnswerConfigContext.Provider>
            </ModeContext.Provider>
          </Container>
        </Page>
      </Body>
    </PageWrapper>
  );
};

export default AgentResultViewer;
